export default __webpack_public_path__ + "static/media/meta-blaster.9965c2b5.jpg";